/**
 * @module Experience/Plan-Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

export const PLAN_DETAILS_CONSTANTS = {
  BACK_ID: 'backButton',
  CHANGE_EXISTING_PLAN_ID: 'changeExistingPlan',
  CLASS: 'btn btn-secondary',
  CLASS_CPS: 'btn btn-primary',
  TYPE: 'secondary',
  PLAN_DETAILS: 'plan-details',
  BILLING_TYPE: 'prepaid',
  GRANDFATHERED: 'GRANDFATHERED',
  PRODUCT_SELECTOR: 'product-selector/setup',
  BORWSE_PLANS_PHONE: '/browse-plans-phone',
  CART_URL: '/cart',
  MIXED_CART_ERROR: 'BIZ_0001_INVALID_TRANS_TYPE',
  CONTINUE: 'continue',
  VIEW_CART: 'viewcart',
};

export const ROUTE_CONSTANTS = {
  HTTP_URL: 'http(s?)://',
  PRODUCT_SELECTOR: 'product-selector/setup',
  BROWSE_PHONES: '/browse-plans-phone',
  HOME: '/home',
  ACCOUNT_LANDING: '/account-landing',
};
